
const storage = window.localStorage;

class TokenStorageService {

    public isUserAuthenticated() {
        return this.getUserInfo() && !this.accessTokenIsExpired();
    }

    public getUserInfo() {
        const getresult = storage.getItem('ReportsUserInfo');
        let result
        if (getresult) {
            result = JSON.parse(getresult);
        } else {
            result = null;
        }

        return result;
    }

    public getSelectedProp() {
        // return storage.getItem('prop_num');
        ;
    }
    public setSelectedProp(prop: any) {
        // storage.setItem('prop_num', prop);
    }

    public getSessionKey() {
        const getUserInfo = this.getUserInfo();
        return getUserInfo.session.session_key;
    }

    public getLoggedInUserID() {
        const getUserInfo = this.getUserInfo();
        if (getUserInfo !== null) {
            return getUserInfo.user.email;
        }
    }

    public updateUserInfo(ReportsUserInfo: any) {
        storage.setItem('ReportsUserInfo', JSON.stringify(ReportsUserInfo));
        console.log("Storage user info updated.");
    }

    public clearUserInfo() {
        storage.removeItem('ReportsUserInfo');
    }

    public getAccessToken() {
        let result: any = null;
        const userInfo: any = this.getUserInfo();
        if (userInfo !== null) {
            result = userInfo.access_token;
        }

        return result;
    }

    public invalidateAccessToken(accessToken: any) {
        if (this.getAccessToken() === accessToken) {
            this.updateUserInfo({
                access_token: 'invalidated',
                expires_in: 0,
                refresh_token: this.getRefreshToken()
            });
        }
    }

    public hasAccessToken(allowInvalidated = true) {
        return (!!this.getAccessToken() && (allowInvalidated || this.getAccessToken() !== 'invalidated'));
    }

    public accessTokenIsExpired() {
        return this.accessTokenWillBeExpired(0);
    }

    public accessTokenWillBeExpired(offsetInMillis = 0) {
        const currentTime = new Date().getTime();
        const timeStamp = this._accessTokenExpirationTimeStamp();
        const result = currentTime + offsetInMillis >= timeStamp;

        if (result) {
            console.log(offsetInMillis > 0 ? " Access token will be expired in " + offsetInMillis + " milliseconds" : "Access token is expired");
        }
        if ((timeStamp - currentTime + offsetInMillis) <= 0) {
            this.clearUserInfo()
        }

        return result;
    }

    public getRefreshToken() {
        let result: any = null;
        const userInfo: any = this.getUserInfo();

        if (userInfo !== null && 'refresh_token' in userInfo) {
            result = userInfo.refresh_token;
        }

        return result;
    }

    public hasRefreshToken() {
        return (!!this.getRefreshToken());
    }

    public _accessTokenExpirationTimeStamp() {
        let result: any = 0;
        const userInfo: any = this.getUserInfo();

        if (userInfo !== null) {
            result = userInfo.session.session_expires_at;
        }
        const datetoTime = new Date(result).getTime()
        return datetoTime;
    }
}

const tokenStorageService = new TokenStorageService();

export default tokenStorageService;


// WEBPACK FOOTER //
// ./src/helpers/tokenStorageService.ts